<div class="error-container">
    <h1>{{ "not_found.title" | translate }}</h1>
    <p>{{ "not_found.message" | translate }}</p>
    <a routerLink="/" class="back-button">{{ "not_found.back" | translate }}</a>
  </div>
